import {
  SET_APP_LOADING,
} from '../../constants';

import { IReduxAction } from '../../interfaces';

interface IAppState {
  loading: boolean;
}

const initState: IAppState = {
  loading: false,
};

export function appReducer(state = initState, action: IReduxAction) {
  switch (action.type) {
    case SET_APP_LOADING:
      return {
        ...state,
        loading: action.payload,
      };

    default:
      return state;
  }
}
